import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        const response = await axios.get('/ActionLog/selectRow',
            {
                params,
            });
        return response.data;
    },
};
